import React from 'react';
import { TableMainToolbarDesktop, TableMainToolbarProps } from './TableMainToolbarDesktop';
import { TableMainToolbarMobile } from './TableMainToolbarMobile';

export interface ExtendedTableMainToolbarProps extends TableMainToolbarProps {
  onToggleSidebar?: () => void;
  isSidebarVisible?: boolean;
}

export function TableMainToolbar(props: ExtendedTableMainToolbarProps) {
  return (
    <>
      <TableMainToolbarDesktop {...props} />
      <TableMainToolbarMobile {...props} />
    </>
  );
}
